//
//
//
//
//
//

import RadioGroup from '../../../../components/radioGroup';

export default ({
  extends: RadioGroup,
});
